export default __webpack_public_path__ + "static/media/contact.ac7ab95c.png";